import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideModal } from "../../../redux/alertModalSlice"; // Import the hide action
import { Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
const AlertModal = () => {
  const dispatch = useDispatch();
  const { isVisible, message, type } = useSelector((state) => state.alertModal);

  const handleClose = () => dispatch(hideModal()); // Dispatch hide action
  const getIcon = () => {
    if (type === "success") {
      return (
        <FontAwesomeIcon
          icon={faCheckCircle}
          size="3x"
          style={{ color: "#04AA6D", marginBottom: "5%" }}
        />
      );
    }
    if (type === "failure") {
      return (
        <FontAwesomeIcon
          icon={faTimesCircle}
          size="3x"
          style={{ color: "#f27474", marginBottom: "5%" }}
        />
      );
    }
    if (type === "warning") {
      return (
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          size="3x"
          style={{ color: "#f0ad4e", marginBottom: "5%" }}
        />
      );
    }
    return null;
  };
  return (
    <Modal
      show={isVisible}
      onHide={handleClose}
      style={{ zIndex: Date.now() }}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {type === "success"
            ? "Success"
            : type === "failure"
            ? "Failure"
            : type === "warning"
            ? "Warning"
            : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          {getIcon()} {/* Show icon based on success or failure */}
          {/* {type === "success" ? " Success" : " Failure"} */}
        </Row>
        <Row className="d-flex justify-content-center">{message}</Row>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default AlertModal;
